const boostListingPaymentStyles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 400,
    margin: '0 auto'
  }
});

export default boostListingPaymentStyles;
